import styled, { css } from 'styled-components';
import { ApIcon, colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
`;

export const Text = styled.div`
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;

	${({ color }) => color && `color: ${color};`};
`;

export const MoreIconWrapper = styled.div`
	visibility: hidden;
	position: absolute;
	left: 0;

	svg {
		transition: none;
	}
`;

export const Cell = styled.div`
	position: relative;
	color: ${colors.grey5};
	min-width: 128px;
	display: flex;
	align-items: center;
	font-size: 13px;
	letter-spacing: 0.3px;
	line-height: 19px;
	border-right: 1px solid ${colors.grey2};
	height: 36px;
	padding: 0 12px;

	&:first-child {
		padding-left: 36px;
	}

	${({ noBorder }) => noBorder && 'border-right: none;'};
`;

export const CellIcon = styled.div`
	display: flex;
	align-items: center;
	min-width: 50px;
	visibility: hidden;
	padding-left: 2px;

	svg {
		transition: none;
	}
`;

export const CellSpacing = styled.div`
	display: flex;
	align-items: center;
	min-width: 30px;
`;

export const SpanWrapper = styled.div`
	display: flex;
	flex-direction: column;
	border-right: 1px solid ${colors.grey2};
	color: ${colors.grey5};

	${({ noBorder }) => noBorder && 'border-right: none;'};
	${({ bgColor }) => bgColor && `background-color: ${bgColor};`};
	${({ borderColor }) =>
		borderColor && `border-right: 1px solid ${borderColor};`};
`;

export const CellSmall = styled.div`
	display: flex;
	align-items: center;
	min-width: 51px;
	max-width: 51px;
	border-right: 1px solid ${colors.grey2};

	${({ borderColor }) =>
		borderColor && `border-right: 1px solid ${borderColor};`};
	${({ bgColor }) => bgColor && `background-color: ${bgColor};`};
	${({ noBorder }) => noBorder && 'border-right: none;'};
`;

export const Row = styled.div`
	display: grid;
	grid-template-columns: minmax(300px, 1fr);
	grid-auto-flow: column;
	width: fit-content;
	min-width: 100%;

	${({ noHover }) =>
		!noHover &&
		css`
			&:hover {
				background-color: ${colors.greyBg};

				${CellIcon} {
					visibility: visible;
				}

				${SpanWrapper}, ${CellSmall} {
					background-color: ${colors.greyBg};
				}

				${MoreIconWrapper} {
					visibility: visible;
				}
			}
		`};
`;

export const HeaderCell = styled(Cell)`
	font-size: 11px;
	line-height: 13px;
	color: ${colors.grey5};
	cursor: default;
`;

export const CellNumber = styled(Cell)`
	justify-content: flex-end;
	padding-right: 16px;
	max-width: 128px;

	span {
		padding-right: 6px;
	}
`;

export const HeaderCellNumber = styled(HeaderCell)`
	text-align: center;
	justify-content: center;
	max-width: 128px;
`;

export const CellSort = styled(Cell)`
	display: flex;
	align-items: center;
	min-width: 90px;
	max-width: 90px;
	border-right: 1px solid ${colors.grey2};
	justify-content: flex-end;
	padding-right: 16px;
`;

export const HeaderCellSort = styled(CellSort)`
	padding: 0 2px;
`;

export const RowSpan = styled.div`
	display: flex;
	align-items: center;
	font-size: 11px;
	color: ${colors.grey5};
	letter-spacing: 0.3px;
	height: 100%;
	border-bottom: 1px solid ${colors.grey2};

	&:last-child {
		border-bottom: none;
	}
`;

export const SpanColumn = styled.div`
	display: flex;
	align-items: center;
	border-right: 1px solid ${colors.grey2};
	min-width: 64px;
	max-width: 64px;
	height: 100%;
	width: 100%;
	padding: 0 2px;
	justify-content: center;

	&:last-child {
		border-right: none;
	}
`;

export const HeaderText = styled.div`
	width: 100%;
	text-align: center;
	font-size: 11px;
	line-height: initial;
	color: ${colors.grey5};
	letter-spacing: 0.3px;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const HeaderLineText = styled.div`
	width: 100%;
	height: 100%;
	font-size: 11px;
	color: ${({ color }) => (color ? color : colors.grey8)};
	letter-spacing: 0.3px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const SpanTextWrapper = styled.div`
	width: 100%;
	padding: 0 4px;
	justify-content: center;
	align-items: center;
	display: flex;
	max-width: 128px;
	min-width: 128px;
`;

export const NoData = styled.div`
	padding: 8px 24px;
`;

export const SortArrow = styled(ApIcon)`
	margin-left: 5px;
	transform: ${({ reverse }) => (reverse ? 'rotate(90deg)' : 'rotate(-90deg)')};
`;

export const SortIconSpace = styled.div`
	min-width: 18px;
`;

export const CheckboxWrapper = styled.div`
	padding-right: 16px;
`;

export const HeaderCellWrapper = styled.div`
	display: flex;
	align-items: center;
	height: 100%;
	width: 100%;
`;

export const HeaderScrollWrapper = styled.div`
	width: 100%;
	min-height: 36px;
	border-bottom: 1px solid ${colors.grey3};
	overflow: hidden;
`;

export const Content = styled.div`
	display: flex;
	height: 100%;
	width: 100%;
	overflow: hidden;
`;
